<template>
  <div
    id="data-list-list-view"
    class="mt-3 data-list-container flipthis-highlight vs-con-loading__container"
  >
    <paginacao-placeholder v-if="loading" />
    <template v-else>
      <vs-table
        ref="table"
        :sst="true"
        :data="descontos"
        @sort="handleOrdenacao"
        noDataText="Nenhum dado disponível com os filtros selecionados."
      >
        <template slot="thead" v-if="descontos.length">
          <vs-th sort-key="id">#</vs-th>
          <vs-th>Cliente</vs-th>
          <vs-th>Associação / Entidade</vs-th>
          <vs-th sort-key="valor">Desconto</vs-th>
          <vs-th>Correspondente</vs-th>
          <vs-th sort-key="created_at">Criação</vs-th>
          <vs-th sort-key="updated_at">Atualização</vs-th>
          <vs-th sort-key="status_id">Status</vs-th>
          <vs-th></vs-th>
        </template>
        <template>
          <tbody>
            <vs-tr :data="desconto" :key="indextr" v-for="(desconto, indextr) in descontos">
              <vs-td>
                <p class="product-name font-medium main-menu-sidebar">{{ desconto.id }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-semibold main-menu-sidebar">{{ desconto.cliente.nome }}</p>
                <span class="flex">
                  <small
                    class="product-name inline-flex font-semibold main-menu-sidebar"
                  >{{ desconto.cliente.cpf }}</small>
                  <small
                    @click="copiarCpf(desconto.cliente.cpf)"
                    class="ml-1 inline-flex main-menu-sidebar"
                  >
                    <vs-icon icon="file_copy" color="primary"></vs-icon>
                  </small>
                </span>
              </vs-td>

              <vs-td>
                <template v-if="desconto.entidade">
                  <p class="product-category main-menu-sidebar">{{ desconto.entidade.nome }}</p>
                  <small
                    class="product-category font-medium main-menu-sidebar"
                  >{{ desconto.associacao.nome }}</small>
                </template>
              </vs-td>

              <vs-td>
                <p class="product-category main-menu-sidebar">{{ desconto.formaPagamento.nome }}</p>
                <small class="product-category font-medium main-menu-sidebar">{{ desconto.valor }}</small>
              </vs-td>

              <vs-td>
                <p class="product-name font-semibold main-menu-sidebar">{{ desconto.usuario.nome }}</p>
                <span class="flex">
                  <small
                    class="product-name inline-flex font-semibold main-menu-sidebar"
                  >{{ desconto.usuario.email }}</small>
                </span>
              </vs-td>

              <vs-td>
                <p
                  class="product-category main-menu-sidebar"
                >{{ desconto.created_at | formatarData }}</p>
                <small
                  class="product-category font-medium main-menu-sidebar"
                >{{ desconto.created_at | formatarHora }}</small>
              </vs-td>

              <vs-td>
                <p
                  class="product-category main-menu-sidebar"
                >{{ desconto.updated_at | formatarData }}</p>
                <small
                  class="product-category font-medium main-menu-sidebar"
                >{{ desconto.updated_at | formatarHora }}</small>
              </vs-td>

              <vs-td>
                <desconto-status :status="desconto.status" :status-motivo="desconto.statusMotivo"></desconto-status>
              </vs-td>

              <vs-td>
                <div class="text-right flex">
                  <vx-tooltip class="inline-flex mr-1" text="Visualizar" position="top">
                    <vs-button
                      radius
                      size="small"
                      color="#c3c3c3"
                      type="border"
                      icon="search"
                      @click="abrirDescontoVisualizar(desconto)"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip class="inline-flex" text="Gerenciar" position="top">
                    <vs-button
                      radius
                      size="small"
                      color="#c3c3c3"
                      type="border"
                      icon="edit"
                      :to="{name: 'gerenciar-contrato', params: { id: desconto.id }}"
                    ></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <paginacao :meta="meta" :handler="handlePaginaSelecionada" />
    </template>
  </div>
</template>

<script>
import DescontoStatus from "../components/StatusContrato";
import PaginacaoPlaceholder from "@/components/placeholders/PaginacaoPlaceholder";

export default {
  name: "paginacao-contratos",
  components: {
    DescontoStatus,
    PaginacaoPlaceholder
  },
  data() {
    return {
      descontos: [],
      meta: {},
      loading: false
    };
  },
  created() {
    this.buscarDescontos(1);
  },
  watch: {
    $route(to) {
      this.buscarDescontos(to.query.page);
    },
    loading(loading) {
      if (loading) {
        this.$vs.loading({
          container: "#data-list-list-view",
          scale: 0.6
        });
      } else {
        this.$vs.loading.close("#data-list-list-view > .con-vs-loading");
      }
    }
  },
  methods: {
    async buscarDescontos(page) {
      this.loading = true;
      let response = await this.$store.getters.fetchContratos({
        page: page,
        status: this.$route.params.status,
        ...this.$route.query
      });

      if (response.data.status) {
        this.descontos = response.data.data;
        this.meta = response.data.meta;
      }
      this.loading = false;
    },
    handlePaginaSelecionada(query) {
      this.$router.push({
        name: "contratos",
        params: { status: this.$route.params.status },
        query
      });
    },
    handleOrdenacao(key, active) {
      this.$router.push({
        name: "contratos",
        params: { status: this.$route.params.status },
        query: {
          ...this.$route.query,
          sortedBy: active ? "asc" : "desc",
          orderBy: key,
          page: 1
        }
      });
    },
    copiarCpf(cpf) {
      this.$copyText(cpf);
      this.$vs.notify({
        title: "Sucesso",
        text: "CPF Foi copiado",
        position: "bottom-center"
      });
    },
    abrirDescontoVisualizar(desconto) {
      this.$router.push({
        name: "visualizar-contrato",
        params: { id: desconto.id }
      });
    }
  }
};
</script>
